<template>
  <div id="app">
    <router-view></router-view>
    <!-- <van-tabbar v-model="active" active-color="#FF4949"  inactive-color="#BCBCBC" route v-show="hasBar">
        <van-tabbar-item v-for="item in tabList" :key="item.url" :name="item.name"  :to="item.url" :exact='item.exact'>
             <span>{{item.name}}</span>
            <template #icon="props">
            <img :src="props.active ? item.active : item.inactive" />
            </template>
        </van-tabbar-item>
     
    </van-tabbar> -->
  </div>
</template>
<script>
import { mapState } from 'vuex'
// import navBar from '@components/Header/index'

export default {
  name: 'App',
  components: {
    //   navBar
  },
    data() {
    return {
      active: 'home',
        tabList:[
            {
                active: require('@/assets/img/tabarIcon/duihuan.png'),
                inactive: require('@/assets/img/tabarIcon/duihuan1.png'),
                name:'兑换',
                url:'/',
                exact:true
            },
            {
                active: require('@/assets/img/tabarIcon/faxian.png'),
                inactive: require('@/assets/img/tabarIcon/faxian1.png'),
                name:'精选',
                url:'/CarefullyChosen',
                exact:false
            },
            {
                active: require('@/assets/img/tabarIcon/wode.png'),
                inactive: require('@/assets/img/tabarIcon/wode1.png'),
                name:'我的',
                url:'/Person',
                exact:false
            },
        ],
      

    };
  },
  created(){
      console.log(123)
      console.log(this.$route)
  },
  
  computed:mapState(['hasBar','barFixed',])

  
}
</script>

<style>
#app{
    height: 100%;
}
.header{
    width: 100%;
    height: 100%;
    
}
</style>
